// # #############################################
// # Title : Checkbox
// # Authors : Sameer, Shubham, Sanjay
// # Date : 15th October 2019
// # Last Modified : July 2019
// # Version : 19.10.03
// # Description : Code for checkbox component used in product and promotion widgets
// # ############################################

import React from "react";
import * as helperFunctions from "../utils/helperFunction";
import "../css/Checkbox.css";

const Checkbox = ({ label, isSelected, onCheckboxChange, type, productClass }) => (
  <div className={productClass}>
    <label className='checkbox-label' id={`${label}_${type}`}>
      <input
        type='checkbox'
        name={label}
        checked={isSelected}
        onChange={onCheckboxChange}
        className='input'
      />
      <span class='checkmark' />
      {helperFunctions.convertToTitleCase(label)}
    </label>
  </div>
);

export default Checkbox;
